import ApiDispatchReservation from '@/modules/api/dispatch/reservations'
import ApiRoutingReservation from '@/modules/api/routing/reservations'

class NotifReservation {
  process (VueApp, payload) {
    let self = this
    let status = payload.status

    if (payload.isPackage === 'true' &&
        (payload.status === 'remove-from-pool' ||
         payload.status === 'move-to-pool' ||
         payload.status === 'break')) {
      self.updatePackagePoolStatus(VueApp, payload)
    }
    self.update(VueApp, payload)
  }

  updatePackagePoolStatus (VueApp, payload) {
    if (payload.status === 'break') {
      // TODO: show reservations in unpackaged
      return
    }
    VueApp.$store.commit('routing/updatePackagePoolStatus', {
      id: parseInt(payload.id),
      inPool: payload.status === 'move-to-pool'
    })
  }

  update (VueApp, payload) {
    let item = {
      id: parseInt(payload.id),
      isPackage: payload.isPackage === 'true'
    }

    if (payload.forRouting === 'false') {
      ApiDispatchReservation.updateItemInTable(VueApp, item)
    }
    ApiRoutingReservation.updateItemsInTables(VueApp, item)
    /*
    if (payload.isPackage === 'true' &&
       (payload.status === 'update' ||
        payload.status === 'accept' ||
        payload.status === 'create' ||
        payload.status === 'cancel' ||
        payload.status === 'break')) {
      ApiRoutingReservation.updateItemsInTables(VueApp, item)
      return
    }

    if (payload.isPackage !== 'true') {
      ApiRoutingReservation.updateItemsInTables(VueApp, item)
    }
    */
  }
}

export default new NotifReservation()



// WEBPACK FOOTER //
// ./src/modules/notifications/notif-reservation.js